import { FormControlLabel, styled, Switch, SwitchProps } from '@mui/material';
import * as React from 'react';

const IOSSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(({ theme }) => ({
    width: 48,
    height: 24,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(24px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#0071CD',
                opacity: 1,
                border: 0
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5
            }
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff'
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600]
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
        }
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 20,
        height: 20
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500
        })
    }
}));
type checkBoxProps = {
    status: boolean;
    onStatusChange: Function;
    id: string;
}
const CustomSwitch: React.FC<checkBoxProps> = ({ onStatusChange, status, id }: checkBoxProps) => {
    const onSwitchStatusChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onStatusChange(event.currentTarget.checked);
    }
    return (
        <>
            <FormControlLabel
                control={<IOSSwitch sx={{ m: 1 }} checked={status} defaultChecked={status} onChange={(event) => onSwitchStatusChange(event)} />}
                id={id}
                data-testid={id}
                label=''
            />
        </>
    );
};

export default React.memo(CustomSwitch);
